/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
          display: `flex`,
          minHeight: `100vh`,
          flexDirection: `column`,
        }}
      >
        <main style={{
          margin: `auto`,
          maxWidth: `600px`,
          flex: 1,
        }}>{children}</main>
        <footer style={{
          margin: `1rem auto`,
          fontSize: `small`,
        }}>
          © {new Date().getFullYear()},
          {` `}
          <a href="https://taogidesign.com">Taogi Limited</a>, All rights reserved.
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
